import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "ui/components/sheet";
import {
  FormField,
  FormItem,
  FormMessage,
} from "ui/components/form";
import { Form } from "react-crud-form";
import { FormLabel } from "components/form";
import { useForm } from "react-hook-form";
import React from "react";
import { Textarea } from "ui/components/textarea";
import { useParams } from "react-router-dom";
import { createTestimonials } from "./api";
import { Button } from "ui/components/button";
import { invalidateAllQueries } from "utils/utils";
import { eventBus } from "utils/eventBus";

export default function CreateTestimonialsDialog({
  open,
  onOpenChange,
}) {
  const form = useForm({
    defaultValues: {
      feedback: "",
    },
  });
  const { casestudyId } = useParams();

  async function handleCreate(context) {
    const values = context.values;
    await createTestimonials({
      item: {
        ...values,
        case_study: casestudyId
      }
    });
    invalidateAllQueries();
    eventBus.emit("refresh:list", `testimonialstestimonials${casestudyId}`);
    form.reset();
    onOpenChange(false);
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Create</SheetTitle>
        </SheetHeader>
        <Form
          form={form}
          create={handleCreate}
          itemId="+"
        >
          {({ isCreating, createItem, isDirty, isNewItem }) => (
            <div className="grid gap-4 overflow-y-auto max-h-[calc(100vh-120px)]">
              {/* Feedback */}
              <div className="px-4">
                <FormField
                  control={form.control}
                  name="feedback"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Feedback</FormLabel>
                      <Textarea {...field} className="min-h-32" />
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>

              <div className="flex justify-end px-4">
                <Button
                  type="button"
                  onClick={createItem}
                  disabled={!isDirty || isCreating}
                  loading={isCreating}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
        </Form>
      </SheetContent>
    </Sheet>
  );
}